module.exports = __webpack_public_path__ + "static/four-2762e0e7c47347db32a783c795882b58.png";